var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1084 2.19995C46.4486 15.4539 40.194 30.0684 40.194 30.0684C40.194 30.0684 45.694 36.3268 43.4698 41.8C43.4698 41.8 41.2016 37.9671 37.3978 37.9671C33.7304 37.9671 31.5766 41.8 24.1978 41.8C7.76818 41.8 0 27.9672 0 27.9672C14.8016 37.7808 24.9084 30.8311 24.9084 30.8311C18.2402 26.9296 4.05457 8.27144 4.05457 8.27144C16.4076 18.8697 21.747 21.6648 21.747 21.6648C18.5614 19.0091 9.62278 6.03276 9.62278 6.03276C16.7728 13.3303 30.9804 23.5114 30.9804 23.5114C35.0152 12.2436 27.1084 2.19995 27.1084 2.19995Z",
    fill: "#CACFE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcode);
export default __webpack_public_path__ + "static/media/xcode.4809f2d210276cb0895f4161359777cc.svg";
export { ForwardRef as ReactComponent };